import React from 'react'
import footerImg from "../assets/footer-logo-img.png"
import { FaFacebookF, FaLinkedinIn, FaTwitter, FaInstagram } from "react-icons/fa";

const Footer = () => {
    return (
        <>
            <div className='footer-main-div'>
                <div className='container'>
                    <div className='row' style={{alignItems: "center", gap: "40px 0"}}>
                        <div className='col-lg-4 col-md-5'>
                            <div className='footer-sec1-div'>
                                <div className='footer-sec1-img-div'>
                                    <img src={footerImg} alt='Image' />
                                </div>
                                <p>
                                    Lorem ipsum dolor sit amet, consetetur sadispscing elitr, sed diam nonumy eirmod tempor invidunt ut labour
                                </p>
                                <div className='footer-sec1-s-div'>
                                    <span>Follow Us</span>
                                    <div className='footer-sec1-s-btn-div'>
                                        <button><FaFacebookF className='footer-sec1-s-btn-icns' /></button>
                                        <button><FaTwitter className='footer-sec1-s-btn-icns' /></button>
                                        <button><FaInstagram className='footer-sec1-s-btn-icns' /></button>
                                        <button><FaLinkedinIn className='footer-sec1-s-btn-icns' /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-5 col-md-7'>
                            <div className='footer-sec2-div'>
                            <h6 >Subscribe to our emails</h6>
                            <p>Be the first to know about new collection and exclusive offers.</p>
                            <input
                            className='footer-sec2-input'
                                type="email"
                                placeholder="Email"
                            />
                            </div>
                        </div>
                        <div className='col-lg-3 '>
                            <div  className='footer-sec3-div'>
                                <h6>Contact Us</h6>
                                <div className='footer-sec3-txt-div'>
                                    <p>Contact Number : </p>
                                    <span>123-456-7890</span>
                                </div>
                                <div className='footer-sec3-txt-div'>
                                    <p>Email us at :</p>
                                    <span>goldndiamond@gmail.com</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer